<template>
  <div style="padding: 18px;">
    <v-col cols="1" style="text-align:end;padding-top:0px;padding-bottom:0px;padding-left:0px;">
      <input-money
        :label="$t('label.total_itens')"
        disabled
        v-model="totalItens">
      </input-money>
    </v-col>
    <v-data-table
      :headers="listaCamposCabecalhos"
      :items="paginaServicos"
      :options.sync="pagination"
      :server-items-length="totalPage"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 30],
      }"
      dense>
      <template v-slot:item="{ item, index }">
          <tr>
            <td class="justify-center px-0">
              <v-tooltip bottom v-if="exibeAcoesItem(item)">
                <template v-slot:activator="{ on }">
                  <v-btn icon class="mx-0" v-on="on" @click.stop="editar(item, index)">
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('label.editar') }}</span>
              </v-tooltip>
              <v-tooltip bottom v-if="exibeAcoesItem(item)">
                <template v-slot:activator="{ on }">
                  <v-btn icon class="mx-0" v-on="on" @click="excluir(item, index)">
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('label.excluir') }}</span>
              </v-tooltip>
            </td>
            <td>
              <span>
                {{ getTipo(item.tipo) }}
              </span>
            </td>
            <td>
              <span>
                {{ item.brand ?  `${item.brand.idExterno} - ${item.brand.nomExtensao}` : '' }}
              </span>
            </td>

            <td>
              <span>
                {{ item.volume ? getNumber(item.volume) : '' }}
              </span>
            </td>

            <td>
              <span>
                {{ item.descricao }}
              </span>
            </td>

            <td>
              <span :style="`${obtemCor(item)};`">
                {{ getMoney(item.vlrunitario) }}
              </span>
            </td>

            <td v-if="isApuracao">
                <v-radio-group v-model="item.indconfirmado" row :disabled="!podeAdicionarItem" @change="recalcularValorAcao">
                  <v-radio :value="true">
                    <template v-slot:label>
                      <div :style="item.indconfirmado != null ? 'color: blue;' : ''">{{ $t('label.sim') }}</div>
                  </template>
                  </v-radio>
                  <v-radio :value="false">
                    <template v-slot:label>
                      <div :style="item.indconfirmado != null ? 'color: red;' : ''">{{ $t('label.nao') }}</div>
                  </template>
                  </v-radio>
                </v-radio-group>
            </td>

          </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="5" style="padding-bottom:0px;padding-left:0px;">
        <v-text-field
            id="instituicaoCliente"
            class="text-instituicao"
            v-model="instituicao"
            v-model.trim="instituicao"
            :label="`${$tc('label.instituicao', 1)} *`"
            :no-data-text="$tc('message.nenhum_registro', 1)"
            :rules="[rules.required]"
            @input="alteraInsituicao"
            maxlength="500"
            :disabled="somenteLeitura || isApuracao"
            required
            :clearable="true"
            >
        </v-text-field>
      </v-col>
      <v-col cols="5" style="padding-bottom:0px;">
        <v-text-field
          id="localEntrega"
          :rules="[rules.required]"
          required
          v-model.trim="localEntrega"
          @input="alteracaoEntrega"
          maxlength="50"
          counter="50"
          :disabled="somenteLeitura || isApuracao"
          :label="`${$tc('label.local_entrega', 1)} *`"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="5" style="padding-bottom:0px;padding-left:0px;">
        <metadados-container-layout
          :metadados-entidade="metadadosParametrizado"
          :layout-class="layoutClass"
          :input-layout="inputLayout"
          :objeto="acao"
          :campos-formulario="camposFormulario"
          :ignora-obrigatorios="false"
          :explode-hierarquia="true"
          :somente-leitura="somenteLeitura || isApuracao">
        </metadados-container-layout>
      </v-col>
      <v-col cols="5" style="padding-bottom:0px;">
        <v-text-field
          id="enderecoEntrega"
          v-model.trim="enderecoEntrega"
          :rules="[rules.required]"
          required
          maxlength="500"
          counter="500"
          @input="alteracaoEntrega"
          :disabled="somenteLeitura || isApuracao"
          :label="`${$tc('label.endereco_entrega', 1)} *`"/>
      </v-col>
      <v-col style="text-align: end;">
        <v-btn fab
          bottom right
          class="v-btn__fab"
          color="primary"
          @click.native="abrirModalServico()"
          v-if="podeAdicionarItem">
          <v-icon>add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <confirm
      ref="confirmDialog"
      :persistent="true">
    </confirm>
    <planejamento-acao-form-detalhes-modal
      ref="modalFormServico"
      :somenteLeitura="somenteLeitura"
      item="itemSelecionado"
      @SALVAR_SERVICO="adicionar"
      @RECALCULAR_TOTAL="recalcularValorAcao"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { generateComputed } from '@/produto/common/functions/roles-computed-generator';
import { getMoney, getNumber } from '@/produto/common/functions/helpers';
import Confirm from '@/produto/shared-components/vuetify/dialog/Confirm';
import InputMoney from '@/produto/shared-components/inputs/InputMoney';
import resourcePlanejamentoAcaoServico from '@/produto/common/resources/planejamento/planejamento-acao-servico';
import MetadadosContainerLayout from '@/produto/shared-components/metadados/MetadadosContainerLayout';
import PlanejamentoAcaoFormDetalhesModal from './PlanejamentoAcaoFormDetalhesModal';
import PlanejamentoAcaoFormAcoesRelacionadasModal from './PlanejamentoAcaoFormAcoesRelacionadasModal';

export default {
  name: 'PlanejamentoAcaoFormDetalhesAcao',
  props: {
    acao: {
      type: Object,
      default: {},
    },
    tipoAcao: {
      type: Object,
      required: true,
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    novaAcao: Boolean,
    configuracao: {
      type: Object,
      required: true,
    },
    isApuracao: {
      type: Boolean,
      default: false,
    },
    editaApuracao: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Confirm,
    InputMoney,
    PlanejamentoAcaoFormDetalhesModal,
    MetadadosContainerLayout,
    PlanejamentoAcaoFormAcoesRelacionadasModal,
  },
  watch: {
    pagination: {
      handler(pagination) {
        if (this.mesmaPagina(pagination, this.lastPagination)) {
          return;
        }

        this.calcularPaginacao();
      },
      deep: true,
    },
    instituicaoSelecionada: {
      handler() {
        this.preencheInstituicao();
      },
    },
    clientes: {
      handler() {
        this.preencheInstituicao();
      },
    },
  },
  data() {
    return {
      planejamentoAcaoServicoResources: resourcePlanejamentoAcaoServico(this.$resource),
      planejamentoAcaoResourceAkzo: this.$api.akzoPlanejamentoAcaoCadastro(this.$resource),
      resourceProjeto: this.$api.akzoAcaoProjeto(this.$resource),

      servicos: [],
      pagination: {},
      lastPagination: {},
      paginaServicos: [],
      totalPage: 0,
      cabecalho: [
        {
          text: this.$tc('label.acoes', 2), value: 'acoes', width: '6%', sortable: true,
        },
        {
          text: this.$tc('label.tipo_item', 1), value: 'tipo', width: '8%', sortable: true,
        },
        {
          text: this.$tc('label.brand', 1), value: 'tipo', width: '15%', sortable: true,
        },
        {
          text: this.$tc('label.volume', 1), width: '7%', value: 'quantidade', sortable: false,
        },
        {
          text: this.$tc('label.descricao', 1), width: '20%', value: 'descricao', sortable: true,
        },
        {
          text: this.$tc('label.valor', 1), width: '9%', value: 'vlrunitario', sortable: false,
        },
      ],
      localEntrega: null,
      enderecoEntrega: null,
      camposDinamicos: [
        { labelCampo: 'tipo_instituicao' },
      ],
      layoutClass: { wrap: true },
      inputLayout: {
        xs12: true,
        sm12: true,
        md12: true,
        sm6: false,
        md3: false,
        md4: false,
        md6: false,
        md9: false,
      },
      metadadosParametrizado: {},
      camposFormulario: {
        padrao: [],
      },
      instituicao: null,
      clientes: [],
      totalItens: 0,
      itemSelecionado: null,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
      },
      instituicaoSelecionada: null,
    };
  },
  computed: {
    ...generateComputed('ACAO', [
      'canEdit',
    ]),
    ...mapGetters('metadados', [
      'getAcaoMetadado',
      'getProdutoMetadado',
    ]),
    isStatusEmAnaliseOuEmCadastro() {
      return this.acao.status === 'Em cadastro'
        || this.acao.status === 'Em análise';
    },
    possuiServicoAdicionadoNaoSalvo() {
      return this.servicos.filter((s) => !s.id).length > 0;
    },
    listaCamposCabecalhos() {
      const campos = this.cabecalho;

      if (this.isApuracao) {
        campos.push({
          text: this.$tc('label.item_confirmado', 1), width: '15%', value: 'indconfirmado', sortable: false,
        });
      }

      return campos;
    },
    podeAdicionarItem() {
      return this.isApuracao ? this.editaApuracao : this.canEdit && this.isStatusEmAnaliseOuEmCadastro && !this.somenteLeitura;
    },
  },
  methods: {
    getMoney,
    getNumber,
    getTipo(tipo) {
      return tipo === 'produto' ? 'Produto' : 'Outro';
    },
    mesmaPagina(p1, p2) {
      return p1.page === p2.page && p1.itemsPerPage === p2.itemsPerPage;
    },
    buscar() {
      if (!this.novaAcao) {
        const params = {
          idAcao: this.$route.params.idAcao,
          page: this.pagination.page,
          size: 50000,
        };
        this.planejamentoAcaoServicoResources.buscar(params)
          .then((res) => {
            const { resposta } = res.data;
            this.servicos = resposta.filter((item) => this.isApuracao || !item.inditemapuracao);
            this.calcularPaginacao();
            this.recalcularValorAcao();
            const s = this.servicos[0];

            if (s) {
              this.localEntrega = s.localentrega;
              this.enderecoEntrega = s.enderecoentrega;
              this.instituicao = s.nomeinstituicao;
            }
            this.servicos.forEach((acao) => {
              if (acao && acao.idextensao) {
                acao.brand = {
                  id: acao.idextensao,
                  idExterno: acao.idexterno,
                  nomExtensao: acao.nomextensao,
                };
              }
              acao.isSustentabilidade = true;
            });
          }, (err) => {
            this.$error(this, err);
            this.$toast(this.$t(err));
          });
      }
    },
    calcularPaginacao() {
      this.totalPage = this.servicos.length;
      const min = this.pagination.itemsPerPage * (this.pagination.page - 1);
      const max = min + this.pagination.itemsPerPage;
      this.paginaServicos = this.servicos.filter((s, i) => i >= min && i < max);
    },
    adicionar(servico) {
      servico.inditemapuracao = this.isApuracao;
      servico.vlrtotalitem = servico.vlrunitario * servico.quantidade;
      if (this.itemSelecionado != null) {
        this.servicos[this.itemSelecionado] = { ...this.servicos[this.itemSelecionado], ...servico };
      } else {
        this.servicos.push(servico);
      }

      if (servico.id) {
        servico.isSustentabilidade = true;
        this.salvarDetalhes(servico);
      }

      this.calcularPaginacao();
      this.recalcularValorAcao();
      this.servicos.forEach((s) => {
        s.localentrega = this.localEntrega;
        s.enderecoentrega = this.enderecoEntrega;
        s.nomeinstituicao = this.instituicao;
        s.isSustentabilidade = true;
      });
    },
    salvarDetalhes(acaoDetalhes) {
      return this.planejamentoAcaoResourceAkzo.atualizaDetalhes(acaoDetalhes)
        .then(() => {
          this.buscar();
          this.$toast(this.$t('message.atualizar_tabela'));
        });
    },
    excluir(item, index) {
      if (!this.novaAcao && item.id) {
        this.planejamentoAcaoServicoResources.deletar({ id: item.id })
          .then(() => {
          }, (err) => {
            this.$error(this, err);
            this.$toast(this.$t(err));
          });
      }

      const idx = (this.pagination.itemsPerPage * (this.pagination.page - 1)) + index;
      this.servicos.splice(idx, 1);

      this.calcularPaginacao();

      if (this.paginaServicos.length === 0) {
        this.pagination.page -= 1;
      }

      this.recalcularValorAcao();
    },
    editar(item, index) {
      this.itemSelecionado = (this.pagination.itemsPerPage * (this.pagination.page - 1)) + index;
      this.$refs.modalFormServico.open(item);
    },
    abrirModalServico() {
      this.itemSelecionado = null;
      this.$refs.modalFormServico.open();
    },
    calcularTotal(item) {
      return this.getMoney(item.quantidade * item.valor);
    },
    recalcularValorAcao() {
      if (this.isApuracao) {
        this.acao.valor = this.servicos.map((item) => (item.indconfirmado === false ? 0 : item.vlrunitario))
          .reduce((prev, next) => prev + next);
      } else if (!this.servicos.length) {
        this.acao.valor = 0;
      } else {
        this.acao.valor = this.servicos.map((item) => item.vlrunitario)
          .reduce((prev, next) => prev + next);
      }

      this.totalItens = this.acao.valor;
      this.$emit('PlanejamentoAcaoFormDetalhesAcao__AlteraValorAcao', this.acao.valor);
    },
    alteraValorAcao() {
      this.$emit('PlanejamentoAcaoFormDetalhesAcao__AlteraValorAcao', this.acao.valor);
    },
    getServicos() {
      return this.servicos;
    },
    alteracaoEntrega() {
      this.servicos.forEach((s) => {
        s.localentrega = this.localEntrega;
        s.enderecoentrega = this.enderecoEntrega;
      });
    },
    alteraInsituicao() {
      this.servicos.forEach((s) => {
        s.nomeinstituicao = this.instituicao;
      });
    },
    validaSecaoDetalheAcao() {
      if (!this.servicos.length) {
        this.$toast(this.$t('errors.adicione_um_servico'));
      }
      return this.servicos.length > 0;
    },
    valorDinamicoAlterado(alteracao) {
      const { mapaEntidades } = this.getProdutoMetadado;
      const dependenciasProduto = Object.keys(mapaEntidades);

      const { label } = alteracao;
      if (label === 'produto' || dependenciasProduto.indexOf(label) >= 0) {
        this.emitirCampoProdutoAlterado();
      }

      if (label === 'valor') {
        const evento = new AcaoComponenteEvento('campoValorAlterado');
        this.$emit('PlanejamentoAcaoForm__evento', evento);
      }
    },
    aplicaParametrizacoes() {
      const camposCustomizados = this.filtraCamposCustomizados();
      const metadados = this.configuracao.aplicaParametrizacao(camposCustomizados);

      this.camposDinamicos.forEach((cd) => {
        metadados.mapaCamposDinamicos[cd.labelCampo].vlrObrigatorio = camposCustomizados.mapaCamposDinamicos[cd.labelCampo].vlrObrigatorio;
        metadados.mapaCamposDinamicos[cd.labelCampo].indAtivo = camposCustomizados.mapaCamposDinamicos[cd.labelCampo].indAtivo;
      });

      this.metadadosParametrizado = metadados;
    },
    filtraCamposCustomizados() {
      const campos = {};
      const { mapaCamposDinamicos } = this.getAcaoMetadado;
      this.camposDinamicos.forEach((cd) => {
        campos[cd.labelCampo] = mapaCamposDinamicos[cd.labelCampo];
      });

      return {
        cabecalho: this.getAcaoMetadado,
        entidade: this.getAcaoMetadado.entidade,
        mapaCamposDinamicos: campos,
      };
    },
    getValoresCamposPadrao() {
      const valores = {};
      const campos = this.camposFormulario.padrao;

      campos
        .filter((campo) => campo.async != null)
        .filter((campo) => {
          const { labelCampo } = campo;
          return this.objeto[labelCampo] != null;
        })
        .forEach((campo) => {
          const { itemValue } = campo.async;
          const { nomCampoId, labelCampo } = campo;
          const objSelecao = this.objeto[labelCampo];

          if (campo.tipoCampo === 'MULTIPLA_ESCOLHA') {
            valores[nomCampoId] = objSelecao
              .map((item) => item[itemValue]);
          } else if (campo.tipoCampo === 'LISTA_CHECKBOX') {
            valores[nomCampoId] = objSelecao;
          } else {
            valores[nomCampoId] = objSelecao[itemValue];
          }
        });

      campos
        .filter((campo) => !campo.async)
        .filter((campo) => {
          const { labelCampo } = campo;
          return this.objeto[labelCampo] != null;
        })
        .forEach((campo) => {
          const { labelCampo } = campo;
          valores[labelCampo] = this.objeto[labelCampo];
        }, this);

      return valores;
    },
    exibeAcoesItem(item) {
      return this.isApuracao ? item.inditemapuracao && this.editaApuracao : this.canEdit && !this.somenteLeitura;
    },
    obtemCor(item) {
      if (item.indconfirmado == null || !this.isApuracao) return '';

      return item.indconfirmado ? 'color: blue' : 'color: red;';
    },
    salvarDetalhesApuracao() {
      return this.planejamentoAcaoResourceAkzo.atualizaDetalhesApuracao({ idAcao: this.acao.idAcao }, this.servicos)
        .then(() => {
          this.buscar();
          this.$toast(this.$t('message.atualizar_tabela'));
        });
    },
    preencheInstituicao() {
      if (!this.clientes.length > 0 && !this.instituicaoSelecionada) return;
      this.clientes.forEach((item) => {
        if (item.id === this.instituicaoSelecionada) {
          this.nomeinstituicao = item;
        }
      });
    },
  },
  mounted() {
    if (!this.novaAcao) {
      this.buscar();
    }

    this.aplicaParametrizacoes();
  },
};
</script>
<style>
.PlanejamentoAcaoTabela__ColunaGrande {
  min-width: 210px;
}
.PlanejamentoAcaoTabela__ColunaMedia {
  min-width: 120px;
}
</style>
;
